export default __webpack_public_path__ + "static/media/MMP_BB_Critical Illness Guide_2025.878d81cf.pdf";